export const GMAIL_DELIVERABILITY_FF = 'gmail-deliverability-update';

export const ROUTES = Object.freeze([
    { route: { name: 'communications.email' }, text: 'Compose an email' },
    { route: { name: 'communications.email.management' }, text: 'Email management' },
]);